module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-solid-900.ttf";